import { render, staticRenderFns } from "./PdpAugRealityModal.vue?vue&type=template&id=2184ac23&scoped=true&"
import script from "./PdpAugRealityModal.vue?vue&type=script&lang=js&"
export * from "./PdpAugRealityModal.vue?vue&type=script&lang=js&"
import style0 from "./PdpAugRealityModal.vue?vue&type=style&index=0&id=2184ac23&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184ac23",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconThreedRotation: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconThreedRotation.vue').default})
